import { Text } from '~/components/ui/Text';
import { StyledContainer } from './Popup.styled';

interface IPopupProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	className?: string;
}

const Popup: React.FC<IPopupProps> = ({
	text,
	className,
	style,
	...rest
}: IPopupProps) => {
	return (
		<StyledContainer className={className} style={style} {...rest}>
			<Text style={{ color: '#000000', fontSize: '14px', fontWeight: 400 }}>
				{text}
			</Text>
		</StyledContainer>
	);
};

export { Popup };
